package alltravelagents.components

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.alpha
import androidx.compose.ui.draw.clip
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import com.essntl.features.travelagent.domain.model.TravelAgentModel
import com.essntl.uikit.components.dropdown.EsDropDownMenu
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing

@Composable
fun TravelAgentCommissionTypeDropDown(
    commissionType: TravelAgentModel.CommissionType?,
    onCommissionTypeSelected: (TravelAgentModel.CommissionType) -> Unit,
    enabled: Boolean = true,
    modifier: Modifier = Modifier,
) {
    var isExpanded by remember {
        mutableStateOf(false)
    }

    Box(
        modifier = modifier
            .alpha(if (enabled) 1f else 0.3f),
    ) {
        TravelAgentCommissionType(
            commissionType = commissionType,
            suffixIconRes = EsIcons.ArrowDown,
            modifier = Modifier
                .clip(CircleShape)
                .pointerHoverIcon(PointerIcon.Hand)
                .clickable {
                    if (enabled)
                        isExpanded = true
                },
        )

        EsDropDownMenu(
            expanded = isExpanded,
            onDismissRequest = { isExpanded = false },
            paddingValues = PaddingValues(1.spacing),
            verticalArrangement = Arrangement.spacedBy(1.5f.spacing),
        ) {
            TravelAgentModel.CommissionType.entries.forEach { commissionType ->
                TravelAgentCommissionType(
                    commissionType = commissionType,
                    modifier = Modifier
                        .clip(CircleShape)
                        .pointerHoverIcon(PointerIcon.Hand)
                        .clickable {
                            onCommissionTypeSelected(commissionType)
                            isExpanded = false
                        },
                )
            }
        }
    }
}